import React from 'react';

interface Props {
  iso2: string;
  label: string;
  className?: string;
}

const CountryFlag = ({ iso2, label, className = '' }: Props): JSX.Element => (
  <img
    src={`https://flagcdn.com/h20/${iso2}.png`}
    srcSet={`https://flagcdn.com/h40/${iso2}.png 2x, https://flagcdn.com/h60/${iso2}.png 3x`}
    height='20'
    alt={label}
    className={`border border-gray-200 ${className}`}
  />
);

CountryFlag.displayName = 'CountryFlag';

export default CountryFlag;
